import {
    CREATE_PHASED_TRAINING_PLAN_ERROR,
    CREATED_PHASED_TRAINING_PLAN,
    CREATING_PHASED_TRAINING_PLAN,
    FETCHING_TRAINING_PLAN_FOR_SETUP,
    FETCHING_TRAINING_PLAN_FOR_SETUP_ERROR,
    FETCHING_TRAINING_PLAN_FOR_SETUP_SUCCESS,
    SKIP_RACE_DAY_STEP,
    RESET_TRAINING_PLAN_SETUP_DATA,
    SET_TRAINING_PLAN_SETUP_DATA,
    RESET_SKIP_RACE_DAY_STEP,
    FETCHING_TRAINING_PLAN_SUCCESS,
    FETCH_USER_CURRENT_TRAINING_DATA_SUCCESS,
    FETCH_USER_CURRENT_TRAINING_DATA_ERROR,
    DELETE_TRAINING_PLAN_SUCCESS,
    DELETING_TRAINING_PLAN,
    DELETE_TRAINING_PLAN_FAIL,
    RESET_TRAINING_PLAN_BY_ID_DATA,
    FETCHING_WORKOUT_SCHEDULE_BY_PERIOD_SUCCESS,
    FETCHING_TRAINING_PLAN,
    DELETE_TRAINING_PLAN_FAIL_BY_IDS,
    DELETE_TRAINING_PLAN_SUCCESS_BY_IDS,
    DELETING_TRAINING_PLAN_BY_IDS
} from 'actions/ActionTypes';
import moment from 'moment';
import DateFormatter from 'backbone/utils/date/DateFormatter';
import { ALL_POSSIBLE_TRAINING_PLAN_DAYS } from 'PhasedTrainingPlan/components/PhasedTrainingPlanSetupPage/PhasedTrainingPlanUtils';
import { SET_TRAINING_PLAN_LEVEL_DATA } from '../../actions/ActionTypes';

let twentyTwoWeeksAfterToday = new moment().add(22, 'weeks').toDate();

const INITIAL_STATE = {
    phasedTrainingPlanSetup: {
        plans: null,
        trainingPlanLevelData: null,
        setupData: {
            hasPowerMeter: false,
            hasHRMonitor: false,
            hasIndoorTrainer: false,
            daysAvailable: [...ALL_POSSIBLE_TRAINING_PLAN_DAYS],
            longRideDay: null,
            eventType: 'Cycling',
            eventSubType: null,
            trainingPlanLevel: null,
            localKey: null,
            startDate: DateFormatter.formatISODate(new Date()),
            eventDate: DateFormatter.formatISODate(twentyTwoWeeksAfterToday),
            trainingPlanName: null,
            currentTrainingLevel: null
        }
    },
    userCurrentTrainingData: null,
    phasedTrainingPlanById: null,
    phasedTrainingPlanByIdSuccess: null,
    skipRaceDayStep: null,
    isFetchingATrainingPlan: false,
    creatingPhasedTrainingPlanInProgress: null,
    createdAPhasedTrainingPlan: false,
    createdPlanError: null,
    workoutScheduleByPeriod: null,
    deletedTrainingPlan: false,
    isDeletingTrainingPlan: false,
    deletedTrainingPlanByIds: false,
    isDeletingTrainingPlanByIds: false
};

const requestTrainingPlansForSetup = (state) => {
    return {
        ...state,
        isFetchingATrainingPlan: true
    };
};

const resetTrainingPlanByIDData = (state) => {
    return {
        ...state,
        phasedTrainingPlanById: INITIAL_STATE.phasedTrainingPlanById
    };
};

const receiveTrainingPlansForSetupSuccess = (state, action) => {
    return {
        ...state,
        isFetchingATrainingPlan: false,
        phasedTrainingPlanSetup: {
            ...INITIAL_STATE.phasedTrainingPlanSetup,
            plans: action.trainingPlan
        }
    };
};

const receiveTrainingPlansForSetupError = (state, action) => {
    return {
        ...state,
        isFetchingATrainingPlan: false,
        phasedTrainingPlanSetup: {
            ...INITIAL_STATE.phasedTrainingPlanSetup
        }
    };
};

const receivedUserCurrentTrainingData = (state, action) => {
    return {
        ...state,
        userCurrentTrainingData: action.userTrainingData
    };
};

const setTrainingPlanSetupData = (state, action) => {
    let valueToAddToData = {};
    valueToAddToData[action.field] = action.value;
    return {
        ...state,
        phasedTrainingPlanSetup: {
            ...state.phasedTrainingPlanSetup,
            setupData: {
                ...state.phasedTrainingPlanSetup.setupData,
                ...valueToAddToData
            }
        }
    };
};

const setTrainingPlanLevelData = (state, action) => {
    let extendObject = {};

    if (action.trainingPlanLevelData && typeof action.trainingPlanLevelData === 'object') {
        extendObject = {
            ...action.trainingPlanLevelData
        };
    }

    return {
        ...state,
        phasedTrainingPlanSetup: {
            ...state.phasedTrainingPlanSetup,
            trainingPlanLevelData: extendObject
        }
    };
};

const fetchingTrainingPlanById = (state, action) => {
    return {
        ...state,
        phasedTrainingPlanByIdSuccess: null
    };
};

const fetchedTrainingPlanById = (success) => (state, action) => {
    return {
        ...state,
        phasedTrainingPlanByIdSuccess: success,
        phasedTrainingPlanById: {
            ...action.trainingPlan
        }
    };
};

const deleteTrainingPlanByID = (success) => (state, action) => {
    return {
        ...state,
        deletedTrainingPlan: success,
        isDeletingTrainingPlan: false
    };
};

const deletingTrainingPlan = (state, action) => {
    return {
        ...state,
        deletedTrainingPlan: false,
        isDeletingTrainingPlan: true
    };
};

const deletingTrainingPlanByIds = (state, action) => {
    return {
        ...state,
        deletedTrainingPlanByIds: false,
        isDeletingTrainingPlanByIds: true
    };
};

const deleteTrainingPlanByIDs = (success) => (state, action) => {
    return {
        ...state,
        deletedTrainingPlanByIds: success,
        isDeletingTrainingPlanByIds: false
    };
};

const resetTrainingPlanSetupData = (state) => {
    return {
        ...INITIAL_STATE,
        phasedTrainingPlanSetup: {
            //do not reset the plan since it is a request that is cached and always gets the same values
            ...INITIAL_STATE.phasedTrainingPlanSetup,
            plans: [...state.phasedTrainingPlanSetup.plans]
        }
    };
};

const createdAPhasedTrainingPlan = (state, action) => {
    return {
        ...state,
        createdAPhasedTrainingPlan: true,
        creatingPhasedTrainingPlanInProgress: false
    };
};

const startedCreatingPhasedTrainingPlan = (state, action) => {
    return {
        ...state,
        creatingPhasedTrainingPlanInProgress: true
    };
};

const createPhasedTrainingPlanError = (state, action) => {
    return {
        ...state,
        creatingPhasedTrainingPlanInProgress: false,
        createdPlanError: { ...action.error }
    };
};

const setSkipRaceDayStep = (state) => {
    return {
        ...state,
        skipRaceDayStep: true
    };
};

const resetSkipRaceDayStep = (state) => {
    return {
        ...state,
        skipRaceDayStep: INITIAL_STATE.skipRaceDayStep
    };
};

const fetchedWorkoutScheduleByPeriod = (state, action) => {
    return {
        ...state,
        workoutScheduleByPeriod: action.workoutScheduleByPeriod
    };
};

const handlers = {
    [FETCHING_TRAINING_PLAN_FOR_SETUP]: requestTrainingPlansForSetup,
    [FETCHING_TRAINING_PLAN_FOR_SETUP_SUCCESS]: receiveTrainingPlansForSetupSuccess,
    [FETCHING_TRAINING_PLAN_FOR_SETUP_ERROR]: receiveTrainingPlansForSetupError,
    [FETCH_USER_CURRENT_TRAINING_DATA_SUCCESS]: receivedUserCurrentTrainingData,
    [SET_TRAINING_PLAN_SETUP_DATA]: setTrainingPlanSetupData,
    [SET_TRAINING_PLAN_LEVEL_DATA]: setTrainingPlanLevelData,
    [RESET_TRAINING_PLAN_SETUP_DATA]: resetTrainingPlanSetupData,
    [CREATED_PHASED_TRAINING_PLAN]: createdAPhasedTrainingPlan,
    [CREATING_PHASED_TRAINING_PLAN]: startedCreatingPhasedTrainingPlan,
    [CREATE_PHASED_TRAINING_PLAN_ERROR]: createPhasedTrainingPlanError,
    [SKIP_RACE_DAY_STEP]: setSkipRaceDayStep,
    [RESET_SKIP_RACE_DAY_STEP]: resetSkipRaceDayStep,
    [FETCHING_TRAINING_PLAN]: fetchingTrainingPlanById,
    [FETCHING_TRAINING_PLAN_SUCCESS]: fetchedTrainingPlanById(true),
    [FETCHING_WORKOUT_SCHEDULE_BY_PERIOD_SUCCESS]: fetchedWorkoutScheduleByPeriod,
    [DELETING_TRAINING_PLAN]: deletingTrainingPlan,
    [DELETE_TRAINING_PLAN_SUCCESS]: deleteTrainingPlanByID(true),
    [DELETE_TRAINING_PLAN_FAIL]: deleteTrainingPlanByID(false),
    [RESET_TRAINING_PLAN_BY_ID_DATA]: resetTrainingPlanByIDData,
    [DELETING_TRAINING_PLAN_BY_IDS]: deletingTrainingPlanByIds,
    [DELETE_TRAINING_PLAN_SUCCESS_BY_IDS]: deleteTrainingPlanByIDs(true),
    [DELETE_TRAINING_PLAN_FAIL_BY_IDS]: deleteTrainingPlanByIDs(false)
};

export const getTrainingPlansForSetup = (state) => state.phasedTrainingPlan.phasedTrainingPlanSetup.plans;
export const getUserCurrentTrainingData = (state) => state.phasedTrainingPlan.userCurrentTrainingData;
export const getTrainingPlanFetchingState = (state) => state.phasedTrainingPlan.isFetchingATrainingPlan;
export const getTrainingPlanSetupData = (state) => state.phasedTrainingPlan.phasedTrainingPlanSetup.setupData;
export const hasCreatedAPhasedTrainingPlan = (state) => state.phasedTrainingPlan.createdAPhasedTrainingPlan;
export const getPhasedTrainingPlanError = (state) => state.phasedTrainingPlan.createdPlanError;
export const isCreatingPhasedTrainingPlan = (state) => state.phasedTrainingPlan.creatingPhasedTrainingPlanInProgress;
export const getSkipRaceDayStep = (state) => state.phasedTrainingPlan.skipRaceDayStep;
export const getPhasedTrainingPlan = (state) => state.phasedTrainingPlan.phasedTrainingPlanById;
export const getDeletedTrainingPlan = (state) => state.phasedTrainingPlan.deletedTrainingPlan;
export const getDeletingTrainingPlanState = (state) => state.phasedTrainingPlan.isDeletingTrainingPlan;
export const getTheWorkoutScheduleByPeriod = (state) => state.phasedTrainingPlan.workoutScheduleByPeriod;
export const getPhasedTrainingFetchingStatus = (state) => state.phasedTrainingPlan.phasedTrainingPlanByIdSuccess;
export const getTrainingPlanLevelData = (state) =>
    state.phasedTrainingPlan.phasedTrainingPlanSetup.trainingPlanLevelData;

export default function phasedTrainingPlan(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
